import { useTranslate } from '@refinedev/core';
import { Card, Tabs, theme } from 'antd';
import type { PublicationDetailOut } from '@/api/generated/schemas';
import { PublicationHero } from '@/components/user_catalog/publications/PublicationHero';
import { PUBLICATION_SHOW_TABS } from '../constants';
import type { PublicationShowTab } from '../constants';

interface PublicationShowHeaderProps {
  record: PublicationDetailOut;
  activeTab: PublicationShowTab;
  onTabChange: (key: string) => void;
}

export const PublicationShowHeader = ({
  record,
  activeTab,
  onTabChange,
}: PublicationShowHeaderProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Card styles={{ body: { paddingBottom: 0 } }}>
      <PublicationHero record={record} />

      <Tabs
        activeKey={activeTab}
        onChange={onTabChange}
        style={{ marginTop: token.marginSM }}
        tabBarStyle={{ marginBottom: 0 }}
        items={PUBLICATION_SHOW_TABS.map((key) => ({
          key,
          label:
            key === 'reviews'
              ? `${t('user_catalog.publications.tabs.reviews')} (${record.reviews_count ?? 0})`
              : key === 'search'
                ? t('user_catalog.common.tabs.search')
                : t(`user_catalog.publications.tabs.${key}`),
        }))}
      />
    </Card>
  );
};
